import { RasaContext } from 'context'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import React from 'react'
import Select from 'react-select'
import { Dataset, DatasetParam } from '../../generic/dataset'
import { Loading } from '../loading'
import { Button } from 'reactstrap'
import { AjaxWrapper, HttpMethod } from "../../generic/ajaxWrapper"
import * as Constants from '../template-library/constants'
import * as GenericRedux from '../../generic/genericRedux'
import { removeExtension } from "../template-library/utils"
import * as Flash from 'components/flash'
import './_styles.scss'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'

interface CopyTemplatesState {
  communityId: string
  isLoading: boolean
  isTemplateLoading: boolean
  selectedCommunityId: any
  templates: any[]
  selectedTemplate: any
  newsletters: any[]
}

const COPY_SUCCESS = 'Template copied successfully!'
const COPY_FAILURE = 'Failed to copy template. Please try again.'

class CopyTemplatesComponent extends RasaReactComponent<any, CopyTemplatesState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  constructor(props: any) {
    super(props, '', {
      communityId: '',
      isLoading: false,
      isTemplateLoading: false,
      selectedCommunityId: null,
      templates: [],
      selectedTemplate: null,
      newsletters: []
    })
  }

  public componentDidMount() {
    this.sharedStore = SharedStore.instance(this.context)
    this.sharedStore.getValue(SharedKeys.activeCommunity)
    .then((activeCommunity) => {
      this.setState({
        communityId: activeCommunity.communityId,
      })
      this.loadNewsletters()
    })
  }

  public render() {
    return (
      <div className="copy-templates-container container py-4 py-md-5">
        {this.state.isLoading ? <Loading size="64"/> :
          <div>
            <h2>Copy Templates</h2>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group">
                  <Select
                    options={this.state.newsletters.map((newsletter) => {
                      return {
                        label: newsletter.display_name || newsletter.community_name || 'Your Newsletter',
                        value: newsletter.community_identifier,
                      }
                    })}
                    value={this.state.selectedCommunityId}
                    onChange={(e) => this.onNewsletterChange(e)}
                    placeholder="Select a newsletter"
                  />
                </div>
              </div>
              {this.state.isTemplateLoading ? <Loading size="64"/> :
              <div className="col-md-6">
                <div className="form-group">
                  <Select 
                    placeholder="Select Template"
                    options={this.state.templates.map((template) => {
                      return {
                        label: template.fileName,
                        value: template.id,
                      }
                    })}
                    value={this.state.selectedTemplate}
                    onChange={(e) => this.onTemplateChange(e)}
                    disabled={!this.state.selectedCommunityId}
                  />
                  {this.state.selectedCommunityId && this.state.templates.length === 0 && (
                    <div className="no-templates-message">
                      No templates available for this newsletter
                    </div>
                  )}
                </div>
              </div>}
            </div>
            <div className="row mt-4">
              <div className="col-12">
                <Button 
                  color="primary"
                  onClick={this.copyTemplate}
                  disabled={!this.state.selectedTemplate || !this.state.selectedCommunityId}
                >
                  Copy Template
                </Button>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

  private loadNewsletters = () => {
    this.setState({ isLoading: true })
    return new Dataset().loadCommunityDataset('userNewsletters')
      .then((newsletters) => {
        this.setState({
          newsletters: newsletters[0],
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({ isLoading: false })
      })
  }

  private onNewsletterChange = (selected: any) => {
    const communityId = selected.value
    this.setState({ 
      selectedCommunityId: selected,
      selectedTemplate: null,
      templates: []
    }, () => {
      if (communityId) {
        this.loadEmailTemplates(communityId)
      }
    })
  }

  private onTemplateChange = (selected: any) => {
    this.setState({ selectedTemplate: selected })
  }

  private loadEmailTemplates = (communityId: string) => {
    this.setState({ isTemplateLoading: true })
    const params: DatasetParam[] = [
      { param: 'load_stripo', value: '1' },
    ]
    return new Dataset().loadCommunityDataset('htmlTemplates', communityId, params)
      .then((htmlTemplates) => {
        // Filter only V2 templates
        const templates = htmlTemplates[0].filter(x => x.type === Constants.TEMPLATE_VERSION.V2)
        templates.map((x) => {
          x.id = removeExtension(x.id)
          x.fileName = removeExtension(x.fileName)
          return x
        })
        this.setState({
          templates,
          isTemplateLoading: false
        })
      })
      .catch(() => {
        this.setState({ isTemplateLoading: false })
      })
  }

  private copyTemplate = () => {
    const selectedCommunityId = this.state.selectedCommunityId.value
    const selectedTemplate = this.state.selectedTemplate.value
    const template = this.state.templates.find(t => t.id === selectedTemplate)
    
    if (!template) return

    this.setState({ isLoading: true })
    
    const url = `${AjaxWrapper.getServerUrl()}/${this.state.communityId}/template/copy`
    AjaxWrapper.ajax(url, HttpMethod.POST, {
      templateId: template.id,
      path: `${template.fileName}`,
      copyFromCommunity: selectedCommunityId,
    })
      .then(() => {
        this.context.store.dispatch(Flash.showFlashMessage(COPY_SUCCESS))
        this.setState({
          isLoading: false,
          selectedTemplate: null
        })
      })
      .catch(() => {
        this.context.store.dispatch(Flash.showFlashError(COPY_FAILURE))
        this.setState({ isLoading: false })
      })
  }
}

export const CopyTemplates = GenericRedux.registerNewComponent<any>(
  CopyTemplatesComponent,
  'copy_templates',
  {}) 